import { Typography } from 'antd';

import type { ModelFinancialPnlResult } from '@app/api/Analytics';
import type { ColumnDataType } from '@app/pages/Analytics/FinancialResultsReport/types';

const { Text } = Typography;

export const transformFinancialResultToTableData = (
  requestData: ModelFinancialPnlResult | undefined
): ColumnDataType[] => {
  const data: ColumnDataType[] = [];

  if (!requestData) {
    return data;
  }

  data.push({
    key: 'fact',
    label: <Text strong>Фактическая реализация</Text>,
    amount: requestData.FactImpl.Amount,
    percentageIncome: requestData.FactImpl.PercentageIncome,
    percentageGrowthPrevMonth: requestData.FactImpl.PercentageGrowthPrevMonth,
    percentageGrowthPrevYear: requestData.FactImpl.PercentageGrowthPrevYear,
  });

  data.push({
    key: 'expenses',
    label: <Text strong>Расходы</Text>,
    amount: requestData.ExpenseTotal.Amount,
    percentageIncome: requestData.ExpenseTotal.PercentageIncome,
    percentageGrowthPrevMonth:
      requestData.ExpenseTotal.PercentageGrowthPrevMonth,
    percentageGrowthPrevYear: requestData.ExpenseTotal.PercentageGrowthPrevYear,
    isExpense: true,
  });

  requestData.ExpensesByArticles?.forEach((item, idx) => {
    data.push({
      key: `expense-${item.ArticleId}-${idx}`,
      label: (
        <Text type="secondary" className="columns__name_details">
          {item.Label}
        </Text>
      ),
      amount: item.Amount,
      percentageIncome: item.PercentageIncome,
      percentageGrowthPrevMonth: item.PercentageGrowthPrevMonth,
      percentageGrowthPrevYear: item.PercentageGrowthPrevYear,
      isExpense: true,
    });
  });

  data.push({
    key: 'profit',
    label: <Text strong>Чистая прибыль</Text>,
    amount: requestData.Profit.Amount,
    percentageIncome: requestData.Profit.PercentageIncome,
    percentageGrowthPrevMonth: requestData.Profit.PercentageGrowthPrevMonth,
    percentageGrowthPrevYear: requestData.Profit.PercentageGrowthPrevYear,
  });

  return data;
};
